// reducer.ts
import { ADD_COURSE, CourseActionTypes } from "../actions/courseAction";

interface Tab {
  id: number;
  name: string;
  order: string;
  status: number;
}

interface CourseState {
  courses: Tab[];
}

const initialState: CourseState = {
  courses: [],
};

const courseReducer = (
  state = initialState,
  action: CourseActionTypes
): CourseState => {
  switch (action.type) {
    case ADD_COURSE:
      return {
        ...state,
        courses: action.payload,
      };
    default:
      return state;
  }
};

export default courseReducer;